import { connect } from 'react-redux';
import ConversionUserInfoChart from './ConversionUserInfoChart';
import { createStructuredSelector } from 'reselect';
import { getConversionUserInfoChart } from './ConversionUserInfoChart.selectors';
import { actions } from './ConversionUserInfoChart.actions';

const mapStateToPropsSelectors = createStructuredSelector({
    item: getConversionUserInfoChart
});

const ConversionUserInfoChartComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.conversionUserInfo.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            init: actions.initConversionUserInfoChart
        };
    }
)(ConversionUserInfoChart);

export default ConversionUserInfoChartComponent;
